<template>
  <div className="box5 flex-col" style="width:45%">
    <div className="section11 flex-col">
      <span className="info13">最近入场记录</span>
      <div className="layer7 flex-col">
        <div className="mod2 flex-row">
          <span className="word26">车牌号</span>
          <span className="word27">车辆类型</span>
          <span className="word28">入场时间</span>
          <span className="word27">入场图片</span>
          <span className="txt7">入场方式</span>
          <span className="txt7">入场备注</span>
          <span className="word29">其他</span>
        </div>
      </div>
      <div className="layer9 main6 flex-col" v-for="item in inCarFltter" :key="item.id">
        <div className="section12 flex-row">
          <span className="word34" style="cursor: pointer;color:#FFF;font-weight:700">{{
            item.numberPlate
          }}</span>
          <div className="outer5 flex-col" style="cursor: pointer;" @click="getCarInfo(item.numberPlate,item.releaseNotice,item.carParkId,item.cfCarParkCarType?.name)">
            <span className="word35">{{ item.cfCarParkCarType?.name }}</span>
          </div>
          <span className="info14">{{ getTime(item?.inTime) }}</span>
          <span className="word36" class="viewImage" @click="viewImage(item,'in')">{{
            '点击查看'
          }}</span>
          <span className="word36">{{
            getReleaseText(item.inReleaseType)
          }}</span>
          <span className="word36">
            <el-tooltip :content="item.releaseNotice" placement="top">
              <template #default>
                <span style="display: block; width: 50px; overflow: hidden; text-wrap: nowrap; text-overflow: ellipsis; cousor: pointer;">
                  {{ item.releaseNotice }}
                </span>
              </template>
            </el-tooltip>
          </span>
          <span className="txt9" @click.stop="editCar(item)">纠错</span>
        </div>
      </div>
    </div>
  </div>

  <div className="box7 flex-col" style="width:45%">
    <div className="wrap5 flex-col">
      <span className="word58">最近出场记录</span>
      <div className="main4 flex-col">
        <div className="outer8 flex-row">
          <span className="word59">车牌号</span>
          <span className="word60">车辆类型</span>
          <span className="word61">入场时间</span>
          <span className="word62">出场时间</span>
          <span className="word61">出场图片</span>
          <span className="txt23">出场备注</span>
          <span className="txt23">出场方式</span>
        </div>
      </div>
      <div className="main6 flex-col" v-for="item in outCarFltter" :key="item.id">
        <div className="main7 flex-row">
          <!-- <span className="word65" @click="getInfo(item.cfCarParkUseLog)">{{
            item.cfCarParkUseLog.numberPlate
          }}</span> -->
          <span className="word65" style="cursor: pointer;color:#FFF;font-weight:700">{{
            item.cfCarParkUseLog?.numberPlate||item.numberPlate
          }}</span>
          <div className="bd14 flex-col" style="cursor: pointer;" @click="getCarInfo(item.numberPlate||item.cfCarParkUseLog
.numberPlate,item.carParkUseLog?.releaseNotice,item.carParkId||item.cfCarPark.
id,item.cfCarParkCarType?.name)">
            <span className="word66">{{ item.cfCarParkCarType?.name }}</span>
          </div>
          <span className="info28">{{
            getTime(item.cfCarParkUseLog?.inTime||item.inTime)
          }}</span>
          
          <span className="info29">{{
            getTime(item.cfCarParkUseLog?.outTime||item.outTime)
          }}</span>
          <span className="info29" class="viewImage" @click="viewImage(item,'out')">{{
           '点击查看'
          }}</span>
          <span className="word36">
            <el-tooltip :content="item.carParkUseLog?.releaseNotice" placement="top">
              <span style="display: block;width: 50px;overflow: hidden;text-wrap: nowrap;text-overflow: ellipsis;">{{item.carParkUseLog?.releaseNotice}}</span>
            </el-tooltip>
          </span>
          <span className="word67">{{
            getReleaseText(item.cfCarParkUseLog?.outReleaseType||item.outReleaseType)
          }}</span>
        </div>
      </div>
    </div>
    <el-dialog v-model="dialogTableVisible" :title="dialogTitle" width="75%" center style="background: #15142d;">
      <!-- <el-table :data="gridData">
        <el-table-column property="date" label="Date" width="150" />
        <el-table-column property="name" label="Name" width="200" />
        <el-table-column property="address" label="Address" />
      </el-table> -->
      <!-- <p v-for="o in 4" :key="o" class="text item">{{ 'List item ' + o }}</p> -->
      <div v-if="carInfo?.length" style="display:flex;justify-content: space-around;">
        <el-card style="min-width: 520px" v-for="(item,index) in carInfo" :key="index">
          <template #header>
            <div class="card-header" style="display:flex;justify-content: space-between; width: 100%;}">
              <span style="font-weight: bold;font-size:20px;">{{item.numberPlate}}</span><span v-if="item.numberPlate == currNumberPlate"><el-tag type="primary" size="small">当前车辆</el-tag></span><span v-else>
                <el-tag type="success" size="small" v-if="item.isInOut==0">未入场</el-tag><el-tag type="danger" size="small" v-if="item.isInOut==1">已入场</el-tag>
              </span>
            </div>
          </template>
          <div class="line-style">
            <span>所属车场:</span><span>{{item.carParkName}}</span>
          </div>
          <div class="line-style">
            <span>所属车位:</span><span style="margin-right:10px">{{item.parkingSpaceLocation}}-{{item.parkingSpaceId}}</span><span v-if="item.vehicleType==1"><el-tag round effect="plain" size="small">普通车位</el-tag></span><span v-if="item.vehicleType==2"><el-tag round effect="plain" size="small">子母车位</el-tag> </span><span v-if="item.vehicleType==3"><el-tag type="warning" round effect="plain" size="small"></el-tag>VIP车位</span>
          </div>
          <!-- <div class="line-style">
            <span>车位车辆:</span><span></span>
          </div> -->
          <div class="line-style">
            <span>业主姓名:</span><span>{{item.carOwnerName}}</span>
          </div>
          <div class="line-style" v-if="phones?.length">
            <div v-for="(phone,i) in item.phones" :key="i">
              <span>联系方式{{i+1}}:</span><span>{{phone}}</span>
            </div>
          </div>
          <div class="line-style" v-else>
            <div>
              <span>联系方式:</span><span>{{'车主未留存联系方式'}}</span>
            </div>
          </div>
          <div class="line-style">
            <span>进出备注:</span><span v-if="item.numberPlate == currNumberPlate" style="color:#fc4408;font-weight: bold;font-size: 16px;">{{releaseNotice||'无'}}</span>
          </div>
          <template #footer>Footer content</template>
        </el-card>
      </div>
      <div v-else style="display:flex;justify-content: space-around;">
        <!-- 不是数组 -->
        <el-card style="max-width: 480px">
          <template #header>
            <div class="card-header" style="display:flex;justify-content: space-between; width: 100%;}">
              <span>{{carInfo.numberPlate}}</span><span v-if="carInfo.numberPlate == currNumberPlate"><el-tag type="primary" size="small">当前车辆</el-tag></span><span v-else>
                <el-tag type="success" size="small" v-if="carInfo.isInOut==0">未入场</el-tag><el-tag type="danger" size="small" v-if="carInfo.isInOut==1">已入场</el-tag>
              </span>
            </div>
          </template>
          <div class="line-style">
            <span>车辆类型:</span><span>{{carTypeName}}</span>
          </div>
          <div class="line-style">
            <span>进出备注:</span><span v-if="carInfo.numberPlate == currNumberPlate">{{releaseNotice||'无'}}</span>
          </div>
          <template #footer>Footer content</template>
        </el-card>
      </div>
      <template #footer>
        <!-- <div class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">
          关闭
        </el-button>
      </div> -->
      </template>
    </el-dialog>
    <el-dialog v-model="showBigImage" :title="showBigImageTitle" class="custom-dialog" center>
      <el-image fit="contain" :src="imageUrl" style="width: 100%; height: 500px;" :preview-src-list="[imageUrl]">
        <template #error>
          <div style=" background-color: #f5f7fa17;width: 100%; margin-left: 0%;height: 500px;margin-top: 0;text-align: center;line-height: 500px;color: #abaeb5;">暂无图片</div>
        </template>
      </el-image>
      <template #footer>
        <!-- <div class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">
          关闭
        </el-button>
      </div> -->
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { $timeFormat } from "../../utils/index";
import { ElMessageBox, ElMessage } from "element-plus";
import { dutyerUpdateUseLog, getOwnerInformation, queryOrderByUseId } from "@/network/api";
import { cloneDeep } from "lodash";
import store from "@/store/index";

export default {
  data() {
    return {
      imageUrl: '',
      carParkReleaseType: [
        { key: 0, name: "未知" },
        { key: 1, name: "自动抬杆" },
        { key: 2, name: "人工抬杆" },
        { key: 3, name: "手机放行" },
      ],
      dialogTableVisible: false,
      showBigImage: false,
      showBigImageTitle: '',
      carInfo: {},
      dialogTitle: '',
      releaseNotice: '',
      currNumberPlate: '',
      carTypeName: ''
    };
  },
  computed: {
    ...mapState(["inCar", "outCar"]),
    ...mapGetters(["carParkId"]),
    inCarFltter() {
      return this.inCar.filter((i) => i.carParkId === this.carParkId);
    },
    outCarFltter() {
      return this.outCar.filter((i) => i.cfCarPark.id === this.carParkId);
    },
  },
  methods: {
    viewImage(item, type) {
      console.log(item)
      if (type === 'in') {
        // this.imageUrl = item.inBigImage
        // this.showBigImageTitle = (item.cfCarParkUseLog?.numberPlate||item.numberPlate) + ' 入场抓拍图片'
        // console.log(item.id)
        this.getQueryOrderByUseId(item.id,'in')
        // this.showBigImage = true
      } else {
        // this.imageUrl = item.cfCarParkUseLog?.outBigImage
        // this.showBigImageTitle = (item.cfCarParkUseLog?.numberPlate||item.numberPlate) + ' 出场抓拍图片'
        // this.showBigImage = true
        // console.log(item.cfCarParkUseLog.id)
        this.getQueryOrderByUseId(item.cfCarParkUseLog.id,'out')
      }
    },

    // 获取账单信息
    async getQueryOrderByUseId(id,type) {
      const { data, code } = await queryOrderByUseId(id);
      if (code != 10002) return;

      // 处理账单信息
      // console.log(data);
      if(type==='in'){
        this.imageUrl = data.cfCarParkUseLog.inBigImage
        this.showBigImageTitle = (data.cfCarParkUseLog.numberPlate) + ' 入场抓拍图片'
        this.showBigImage = true
      }else{
        this.imageUrl = data.cfCarParkUseLog.outBigImage
        this.showBigImageTitle = (data.cfCarParkUseLog.numberPlate) + ' 出场抓拍图片'
        this.showBigImage = true
      }
    },

    getTime(time) {
      // console.log(time,666)
      return $timeFormat(time, "MM-DD HH:mm:ss");
    },
    async getCarInfo(numberPlate, releaseNotice, carParkId, carTypeName) {
      // console.log(numberPlate)
      this.currNumberPlate = numberPlate
      this.carTypeName = carTypeName
      const { code, data, message } = await getOwnerInformation({
        numberPlate: numberPlate, carParkId: carParkId
      })
      if (code == 10002) {
        this.carInfo = data
        this.dialogTitle = numberPlate + '相关车辆信息'
        this.releaseNotice = releaseNotice
        this.dialogTableVisible = true
      } else {
        ElMessage({
          type: "error",
          message,
        });
      }
      console.log(code, data)
    },
    // 获取车牌号
    async getInfo(value) {
      console.log("value", value);
      // let conditions = {
      //   like: {
      //     list: {
      //       id: {
      //         "0": {
      //           value: value.id,
      //           alias: "cpul",
      //         },
      //       },
      //     },
      //     operator: "like",
      //   },
      //   order: {
      //     list: {
      //       create_time: {
      //         type: "desc",
      //         alias: "cpul",
      //       },
      //     },
      //     operator: "order",
      //   },
      //   limit: {
      //     operator: "limit",
      //     page: 1,
      //     limit: 20,
      //   },
      // };
      // const res = await getNewOutLog({
      //   conditions: conditions,
      // });
      // console.log("查询结果",res);
      // store.commit("SETNEWINFO", res.data[0]);
    },
    getReleaseText(type) {
      return this.carParkReleaseType.filter((i) => i.key == type)[0]?.name;
    },
    editCar(item) {
      ElMessageBox.prompt("请输入修改后的车牌号", "提示", {
        inputValue: item.numberPlate,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(async ({ value }) => {
        var { code, message } = await dutyerUpdateUseLog({
          numberPlate: value,
          carParkUseLogId: item.id,
        });
        if (code === 10002) {
          // 修改车牌后 改变本地的数据
          var list = cloneDeep(this.inCar);
          list.map((i) => {
            if (i.id === item.id) {
              i.numberPlate = value;
            }
          });
          store.commit("SETALLINCAR", list);
          ElMessage({
            type: "success",
            message,
          });
        } else {
          ElMessage({
            type: "error",
            message,
          });
        }
      });
    },
  },
  watch: {
    // inCar: function (value) {
    //   console.log("value", value);
    // },
  },
};
</script>
<style>
.line-style {
  line-height: 30px;
  height: 30px;
}
.main6:hover {
  background: #656768;
}
.viewImage {
  cursor: pointer;
  color: #fff;
}
.viewImage:hover {
  color: #409eff;
  text-decoration: underline;
  cursor: pointer;
}
</style>
<style scoped>
/deep/ .el-dialog__title {
  color: #f56c6c; /* 修改标题文字颜色（示例红色） */
  font-weight: bold; /* 可选：加粗标题 */
}
/deep/ .el-dialog {
  background-color: #2c2c2c; /* 深色背景 */
  color: #fff; /* 修改文字颜色 */
}
/deep/ .el-dialog__header {
  background-color: #1f1f1f; /* 标题栏背景 */
}
/deep/ .el-dialog__body {
  background-color: #2c2c2c; /* 内容区域背景 */
}
</style>